module.exports = __webpack_public_path__ + "static/media/Klavika-Bold.e6ccbe88.woff";